export default __webpack_public_path__ + "static/media/rate.456f5d14.svg";